<template>
    <div>
        <router-link :to="{name: 'discount-create' }" class="button is-primary is-pulled-right">
            Add discount
        </router-link>

        <data-table :data-set="discounts" :page-length="50" :columns="[
            {name: 'Code', type: 'text', prop: 'code'},
            {name: 'Name', type: 'text', prop: 'name'},
            {name: 'Updated', type: 'date', prop: 'updated_at', filter: ['moment', ['from', 'now']]},
            {name: 'Created', type: 'date', prop: 'created_at', filter: ['moment', ['from', 'now']]},
        ]">
            <template slot="column_Code" slot-scope="props">
                <router-link :to="{name: 'discount', params: {id: props.row.id}}">
                    {{ props.row.code }}
                </router-link>
            </template>
            <template slot="column_Name" slot-scope="props">
                <router-link :to="{name: 'discount', params: {id: props.row.id}}">
                    {{ props.row.name }}
                </router-link>
            </template>
            <template slot="controls" slot-scope="props">
                <td>
                    <div class="has-text-right">
                        <a v-if="props.row.enabled" @click="disableDiscount(props.row)">
                            Enabled <span class="icon"><i class="fa fa-toggle-on"></i></span>
                        </a>
                        <a v-else="props.row.enabled" @click="enableDiscount(props.row)">
                            Disabled <span class="icon"><i class="fa fa-toggle-off"></i></span>
                        </a>
                        &nbsp;
                        <a class="delete" @click="deleteDiscount(props.row)"></a>
                    </div>
                </td>
            </template>
        </data-table>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import {UPDATE_DISCOUNT, DELETE_DISCOUNT} from "../../../store/mutation-types";
    export default {
        name: 'discount-list',
        data () {
            return {}
        },
        computed: mapGetters(['discounts']),
        methods: {
            deleteDiscount(discount) {
                this.$store.dispatch(DELETE_DISCOUNT, discount)
            },
            enableDiscount(discount) {
                let newDiscount     = Object.assign({}, discount)
                newDiscount.enabled = true
                this.$store.dispatch(UPDATE_DISCOUNT, {discount, newDiscount})
            },
            disableDiscount(discount) {
                let newDiscount     = Object.assign({}, discount)
                newDiscount.enabled = false
                this.$store.dispatch(UPDATE_DISCOUNT, {discount, newDiscount})
            }
        }
    }
</script>



// WEBPACK FOOTER //
// DiscountList.vue?32af6d37